import { Injectable } from '@angular/core';
import { CarrierMarketplaceMappingRequestModel } from '../models/request-models/carrier-marketplace-mapping-request.model';
import { CarrierMarketplaceMappingResponseModel } from '../models/response-models/carrier-marketplace-mapping-response.model';
import { CarrierMarketplaceMappingViewModel } from '../models/view-models/carrier-marketplace-mapping-view.model';

@Injectable({
  providedIn: 'root',
})
export class CarrierMarketplaceMappingMapperService {
  buildViewFromResponse(
    response: CarrierMarketplaceMappingResponseModel,
  ): CarrierMarketplaceMappingViewModel {
    const view = new CarrierMarketplaceMappingViewModel();
    view.id = response.id;
    view.carrierId = response.carrierId;
    view.companyId = response.companyId;
    view.carrierName = response.carrierName;
    view.marketplace = response.marketplace;
    view.shippingName = response.shippingName;
    view.shippingCode = response.shippingCode;
    return view;
  }

  buildViewsFromResponse(
    responses: CarrierMarketplaceMappingResponseModel[],
  ): CarrierMarketplaceMappingViewModel[] {
    return (responses ?? []).map((item) => this.buildViewFromResponse(item));
  }

  buildRequestFromView(
    view: CarrierMarketplaceMappingViewModel,
  ): CarrierMarketplaceMappingRequestModel {
    const request = new CarrierMarketplaceMappingRequestModel();
    request.carrierId = view.carrierId;
    request.companyId = view.companyId;
    request.marketplace = view.marketplace;
    request.shippingName = view.shippingName;
    request.shippingCode = view.shippingCode;
    return request;
  }
}
